"use client"

import { MessageSquareHeart } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MessageSquareHeartIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MessageSquareHeartIcon = component(Icon)({
  as: MessageSquareHeart,
})
